<template>
  <div class="v-icon mr-2">
    <v-dialog
      :value="editPersonAvailabilityDialog"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-card-title
          class="pt-1 pb-1 headline grey lighten-2"
          color="primary"
          primary-title
        >
          <span class="headline">{{ dialogName }}</span>
          <v-spacer />
          <v-btn @click.stop="closeEditItem()" fab rounded small text>
            X
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-select
                  :error-messages="editYearErrors"
                  :items="fiscalYearsRemainingForPersonExceptEditYearList"
                  @blur="$v.editYear.$touch()"
                  @input="$v.editYear.$touch()"
                  label="Year (FY)"
                  v-model="editYear"
                />
              </v-flex>
              <v-flex md4 sm6 xs12>
                <v-text-field
                  :error-messages="editWorkingDaysErrors"
                  @blur="$v.editWorkingDays.$touch()"
                  @input="$v.editWorkingDays.$touch()"
                  label="Working Days"
                  max="365"
                  min="0"
                  step="0.5"
                  type="number"
                  v-model="editWorkingDays"
                />
              </v-flex>
              <v-flex md4 sm6 xs12>
                <v-text-field
                  :error-messages="editHolidayEntitlementErrors"
                  @blur="$v.editHolidayEntitlement.$touch()"
                  @input="$v.editHolidayEntitlement.$touch()"
                  label="Yearly Entitlement"
                  max="100"
                  min="0"
                  step="0.5"
                  type="number"
                  v-model="editHolidayEntitlement"
                />
              </v-flex>
              <v-flex md4 sm6 xs12>
                <v-text-field
                  :error-messages="editCarriedOverErrors"
                  @blur="$v.editCarriedOver.$touch()"
                  @input="$v.editCarriedOver.$touch()"
                  label="Carried Over"
                  max="100"
                  min="0"
                  step="0.5"
                  type="number"
                  v-model="editCarriedOver"
                />
              </v-flex>
              <v-flex md4 sm6 xs12>
                <v-text-field
                  :error-messages="editSpecialAllowanceErrors"
                  @blur="$v.editSpecialAllowance.$touch()"
                  @input="$v.editSpecialAllowance.$touch()"
                  label="Special Allowance"
                  max="100"
                  min="0"
                  step="0.5"
                  type="number"
                  v-model="editSpecialAllowance"
                />
              </v-flex>
              <v-flex md4 sm6 xs12>
                <v-text-field
                  :error-messages="editBankHolidayErrors"
                  @blur="$v.editBankHoliday.$touch()"
                  @input="$v.editBankHoliday.$touch()"
                  label="Bank Holiday"
                  max="100"
                  min="0"
                  step="0.5"
                  type="number"
                  v-model="editBankHoliday"
                />
              </v-flex>
              <v-flex md12 sm12 xs12>
                <v-text-field label="Comments" v-model="editComments" />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn @click="saveEditItemAndCloseDialog" color="green" text>
            Save
          </v-btn>
          <v-btn @click="closeEditItem" color="red darken-1" text>
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import EditTableFunctions from "../editTableFunctions";
import {
  LOAD_PERSON_AVAILABILITY_TO_EDIT,
  RESET_DEFAULT_PERSON_AVAILABILITY_TO_EDIT,
  TOGGLE_EDIT_PERSON_AVAILABILITY_DIALOG,
  UPDATE_EDIT_PERSON_AVAILABILITY_FIELD,
} from "@/store/person_availability/mutations";
import {
  FETCH_PERSON_AVAILABILITY_LIST,
  SAVE_EDITED_PERSON_AVAILABILITY,
} from "@/store/person_availability/actions.js";
import { required } from "vuelidate/lib/validators";

export default {
  name: "EditPersonAvailabilityDialog",

  validations: {
    editYear: { required },
    editWorkingDays: { required },
    editCarriedOver: { required },
    editHolidayEntitlement: { required },
    editSpecialAllowance: { required },
    editBankHoliday: { required },
  },
  components: {},
  mixins: [EditTableFunctions],
  props: {
  },
  data() {
    return {
      dialogName: "Edit Availability",
    };
  },
  computed: {
    editPersonAvailabilityDialog: {
      get() {
        return this.$store.state.person_availability
          .editPersonAvailabilityDialog;
      },
    },
    editYear: {
      get() {
        return this.$store.state.person_availability.editPersonAvailability
          .year;
      },
      set(value) {
        this.updateEditedValue("year", value);
      },
    },
    editYearErrors() {
      const errors = [];
      if (!this.$v.editYear.$dirty) return errors;
      !this.$v.editYear.required && errors.push("required.");
      return errors;
    },
    editWorkingDays: {
      get() {
        return this.$store.state.person_availability.editPersonAvailability
          .workingDays;
      },
      set(value) {
        value = Math.abs(value);
        this.updateEditedValue("workingDays", value);
      },
    },
    editWorkingDaysErrors() {
      const errors = [];
      if (!this.$v.editCarriedOver.$dirty) return errors;
      !this.$v.editWorkingDays.required && errors.push("required.");
      return errors;
    },
    editCarriedOver: {
      get() {
        return this.$store.state.person_availability.editPersonAvailability
          .carriedOver;
      },
      set(value) {
        value = Math.abs(value);
        this.updateEditedValue("carriedOver", value);
      },
    },
    editCarriedOverErrors() {
      const errors = [];
      if (!this.$v.editCarriedOver.$dirty) return errors;
      !this.$v.editCarriedOver.required && errors.push("required.");
      return errors;
    },
    editBankHoliday: {
      get() {
        return this.$store.state.person_availability.editPersonAvailability
          .bankHolidayDays;
      },
      set(value) {
        value = Math.abs(value);
        this.updateEditedValue("bankHolidayDays", value);
      },
    },
    editBankHolidayErrors() {
      const errors = [];
      if (!this.$v.editCarriedOver.$dirty) return errors;
      !this.$v.editCarriedOver.required && errors.push("required.");
      return errors;
    },
    editHolidayEntitlement: {
      get() {
        return this.$store.state.person_availability.editPersonAvailability
          .holidayEntitlement;
      },
      set(value) {
        value = Math.abs(value);
        this.updateEditedValue("holidayEntitlement", value);
      },
    },
    editHolidayEntitlementErrors() {
      const errors = [];
      if (!this.$v.editHolidayEntitlement.$dirty) return errors;
      !this.$v.editHolidayEntitlement.required && errors.push("required.");
      return errors;
    },
    editSpecialAllowance: {
      get() {
        return this.$store.state.person_availability.editPersonAvailability
          .specialAllowance;
      },
      set(value) {
        value = Math.abs(value);
        this.updateEditedValue("specialAllowance", value);
      },
    },
    editSpecialAllowanceErrors() {
      const errors = [];
      if (!this.$v.editSpecialAllowance.$dirty) return errors;
      !this.$v.editSpecialAllowance.required && errors.push("required.");
      return errors;
    },
    editComments: {
      get() {
        return this.$store.state.person_availability.editPersonAvailability
          .comments;
      },
      set(value) {
        this.updateEditedValue("comments", value);
      },
    },
    ...mapGetters([
      "editPersonAvailabilityDialog",
      "fiscalYearList",
      "fiscalYearsRemainingForPersonExceptEditYearList",
      "editPersonAvailabilityInitialLoadFiscalYear",
    ]),
  },

  methods: {
    ...mapActions({
      fetchItem: FETCH_PERSON_AVAILABILITY_LIST,
      updateTableItemRecord: SAVE_EDITED_PERSON_AVAILABILITY,
    }),
    ...mapMutations({
      toggleEditDialog: TOGGLE_EDIT_PERSON_AVAILABILITY_DIALOG,
      loadTableItemToEdit: LOAD_PERSON_AVAILABILITY_TO_EDIT,
      updateTableItemToEdit: UPDATE_EDIT_PERSON_AVAILABILITY_FIELD,
      resetEditItemToDefault: RESET_DEFAULT_PERSON_AVAILABILITY_TO_EDIT,
    }),
  },
};
</script>

<style scoped>
</style>
